<header>
  <h4>Open document</h4>
</header>

<main class="d-flex align-items-stretch">
  <nav>
    <h5 class="nav-header">TXdocs Online</h5>
    <ul class="nav flex-column w-100">
      <li class="nav-item">
        <a
          href="#"
          (click)="changeComponent(openMenuItems.ClientCase)"
          class="nav-link"
          [ngClass]="{ active: activeComponent === openMenuItems.ClientCase }">
          <i class="bi-briefcase"></i>
          <span>Client Documents</span>
        </a>
      </li>
      <li class="nav-item">
        <a
          href="#"
          (click)="changeComponent(openMenuItems.Browse)"
          class="nav-link"
          [ngClass]="{ active: activeComponent === openMenuItems.Browse }">
          <i class="bi-folder"></i>
          <span>Firm Documents</span>
        </a>
      </li>
    </ul>
    <h5 class="nav-header">This PC</h5>
    <ul class="nav flex-column w-100">
      <li class="nav-item">
        <a
          href="#"
          (click)="changeComponent(openMenuItems.ThisPC)"
          class="nav-link"
          [ngClass]="{ active: activeComponent === openMenuItems.ThisPC }">
          <i class="bi-pc-display"></i>
          <span>Browse</span>
        </a>
      </li>
    </ul>
  </nav>
  <div [ngSwitch]="activeComponent" class="p-4 pt-2 overflow-auto flex-fill">
    <div *ngIf="activeComponent == openMenuItems.ClientCase" class="mb-4 d-flex align-items-center gap-3">
      <label>Selected case:</label>

      <div class="flex-fill">
        <tx-client-case-tree
          [preselectedContactId]="preselectedContactId"
          [preselectedCaseId]="preselectedCaseId"
          (caseSelected)="CaseSelected($event)"></tx-client-case-tree>
      </div>
    </div>

    <tx-client-case-documents
      *ngSwitchCase="openMenuItems.ClientCase"
      (openDocument)="openDocument.emit($event)"
      (openInNewTab)="openInNewTab.emit($event)"
      [selectedCaseId]="selectedCaseId"
      [existingDocument]="existingDocument"
      [fileMenuAction]="fileMenuActions.Open"
      [isPdf]="isPdf"
      [isDirty]="isDirty"></tx-client-case-documents>
    <tx-browse-documents
      *ngSwitchCase="openMenuItems.Browse"
      [isDirty]="isDirty"
      [existingDocument]="existingDocument"
      (openDocument)="openDocument.emit($event)"
      (openInNewTab)="openInNewTab.emit($event)"></tx-browse-documents>
    <tx-upload-document
      *ngSwitchCase="openMenuItems.ThisPC"
      (uploadDocument)="uploadDocument.emit($event)"></tx-upload-document>
  </div>
</main>
